import * as XLSX from "xlsx";

export interface LeadRow {
  Nome: string;
  Email: string;
  Telemóvel: string;
  "Última reserva": string;
  "Dias sem reservar": number | string;
  Reservas: number;
  "Total gasto (€)": number;
  "Ticket médio (€)": number;
  Faixa?: string;
}

/** Exporta uma ou várias folhas para um ficheiro .xlsx */
export function exportSheets(
  sheets: { name: string; rows: Record<string, any>[] }[],
  fileName: string,
) {
  const wb = XLSX.utils.book_new();
  let added = 0;
  for (const s of sheets) {
    if (!s.rows.length) continue;
    const ws = XLSX.utils.json_to_sheet(s.rows);
    const cols = Object.keys(s.rows[0]).map((k) => ({
      wch: Math.min(
        40,
        Math.max(k.length + 2, ...s.rows.slice(0, 200).map((r) => String(r[k] ?? "").length + 2)),
      ),
    }));
    (ws as any)["!cols"] = cols;
    XLSX.utils.book_append_sheet(wb, ws, s.name.slice(0, 31));
    added++;
  }
  if (!added) return false;
  XLSX.writeFile(wb, fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
  return true;
}

export function todayStamp() {
  return new Date().toISOString().split("T")[0];
}
